
























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Cell } from "vant";
import moment from "moment";
import _ from "lodash";
import roleUtils from "@/utils/roleUtils";
import baseService from "@/service/baseService";
import { md5 } from "@/utils/md5";

class PassengerInfo {
  "RoleID": "S00008447832";
  "ConsumerID": "S00008447832";
  "ConsumerType": 1705;
  "Birthday": "1998-07-12T00:00:00";
  "ContactMobile": "18337466496";
  "ContactEmail": "1435607771@qq.com";
  "CardNo": "CC1234568";
  "CardType": 1139;
  "CardOverDate": "2021-04-21";
  "ConsumerSex": 1145;
  "CountryID": 151;
  "CountryCode": "CN";
  "NotifyType": "1865";
  "ConsumerPreference": "";
  "MainlandCode": 86;
  "IsSave": true;
  "ConsumerName": ''
  "EnglishFirstName": "ZHANG";
  "EnglishLastName": "SAN";
}
@Component({
  components: {
    [Cell.name]: Cell,
    // [Overlay.name]: Overlay,
    // [Dialog.name]: Dialog
  }
})
export default class Flight extends Vue {
  @Prop({ default: false })
  showDialog!: boolean;

  @Prop({ default: [] })
  consumers!: PassengerInfo[]

  get active(): PassengerInfo {
    return this.consumers && this.consumers[0];
  }
  activeIndex = 0;

  mounted() {
    this.loadData();
    this.loadCountryData();
  }
  loadData() {
    this.activeIndex = 0;
  }
  beforeClose(action: any, done: any) {
    done(false)
  }
  confirm() {
    localStorage.setItem(`${md5(this.active.CardNo)}`, '1');
    this.consumers.splice(0, 1)
    if (this.consumers.length == 0) {
      this.showDialog = false;
      this.$emit("close", true);
    }
  }
  cancel() {
    this.showDialog = false;
    this.$emit("close", false);
  }

  formatText(message?: string) {
    return `${message}`;
  }
  formatDate(value?: string) {
    return moment(value).format('YYYY-MM-DD');
  }

  CountryDatas: any[] = [];
  loadCountryData() {
    let data = { ZoneType: "1442", PageSize: 999999 };
    baseService.getZoneList(data).then(res => {
      if (res.isSucc) {
        this.CountryDatas = res.result.entities;
      }
    });
  }
  getCountryName(val?: any) {
    let Country: any = _.find(this.CountryDatas, item => item.ZoneID == val);
    return Country && Country.CountryName;
  }
  formatCardType(value: number) {
    return roleUtils.BuildCardTypes((key: string) => this.$t(key) as string).filter((o: any) => o.value == value)[0].text;
  }

  formatGenre(val?: any) {
    let Genres = [
      { code: 1145, text: this.$root.$t("mall_modules_editrole_nan") as string },
      { code: 1146, text: this.$root.$t("mall_modules_editrole_nv") as string },
    ];
    let Genre: any = _.find(Genres, item => {
      return item.code == val;
    });
    return (Genre || Genres[0]).text;
  }
}
